export default __webpack_public_path__ + "static/media/Millimeterpapier.19966bbb.svg";